import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

import {
    LOGO_HEIGHT,
    LOGO_SRC,
    LOGO_WIDTH
} from '@/constants/site'

/* The boy from the official logo, framed on his face */
export const MascotAvatar: FC<{ className?: string, imageClassName?: string }> = ({ className, imageClassName }): ReactNode => {
    return (
        <span className={cn('relative block overflow-hidden rounded-full border-2 border-brand-choco bg-white', className)}>
            <Image
                src={LOGO_SRC}
                alt=''
                width={LOGO_WIDTH}
                height={LOGO_HEIGHT}
                sizes='160px'
                className={cn('absolute left-1/2 top-[-12%] w-[132%] max-w-none -translate-x-1/2', imageClassName)}
            />
        </span>
    )
}
